const IF = require( "infrontjs" );

import pageTemplate from './RoutineSettingsPageTemplate.html';
import listTemplate from './RoutineSettingsListTemplate.html';
import addNewTemplate from './RoutineSettingsAddNewTemplate.html';

import { InAppState } from "../base/InAppState";
import { RoutinePlan } from "../../model/RoutinePlan";
import { Routine } from "../../model/Routine";

import './../../components/routine/routine-selection-edit';

export class RoutineSettingsState extends InAppState
{
    static ROUTE = '/routine/settings';
    static ID = 'routine-settings';

    async enter()
    {
        this.app.container.innerHTML = this.app.view.getHtml( pageTemplate );

        this.loadPageContent();
        this.app.container.querySelector( '[data-id="btnAction"]' ).addEventListener( 'click', () =>
        {
            if ( this.routinePlan === null )
            {
                return;
            }


            this.app.gui.showGenericModal(
                this.app.view.getHtml(
                    addNewTemplate,
                    {
                        routinePlan : this.routinePlan,
                        morningRoutines : this.app.routineManager.getRoutinesByCategoryId( Routine.CATEGORY_DAILY_MORNING ),
                        middayRoutines : this.app.routineManager.getRoutinesByCategoryId( Routine.CATEGORY_DAILY_MIDDAY ),
                        eveningRoutines : this.app.routineManager.getRoutinesByCategoryId( Routine.CATEGORY_DAILY_EVENING ),
                        weeklySportRoutines : this.app.routineManager.getRoutinesByCategoryId( Routine.CATEGORY_WEEKLY_GOAL_SPORT ),
                        weeklyConsumeRoutines : this.app.routineManager.getRoutinesByCategoryId( Routine.CATEGORY_WEEKLY_GOAL_CONSUME ),
                        weeklySpiritRoutines : this.app.routineManager.getRoutinesByCategoryId( Routine.CATEGORY_WEEKLY_GOAL_SPIRIT ),
                    }
                )
            );

            const addNewContainer = this.app.gui.getGenericModalContainer();
            const onCloseAddNewContainer = () => {
                addNewContainer.querySelectorAll( '[data-type="btnAdd"]' ).forEach( btn => btn.removeEventListeners( 'click' ) );
                addNewContainer.querySelectorAll( '[ data-type="weekly-frequence-selector"]' ).forEach(  select=> select.removeEventListeners( 'change' ) );
                addNewContainer.querySelector( '[data-id="btnCancel"]' ).removeEventListeners( 'click' );
                addNewContainer.querySelector( '[data-id="btnSelectIndividualIcon"]' ).removeEventListeners( 'click' );
                addNewContainer.querySelector( '[data-id="btnAddIndividual"]' ).removeEventListeners( 'click' );
                addNewContainer.querySelector( '[data-id="addIndividualRoutineCategoryId"]' ).removeEventListeners( 'click' );
                this.app.gui.closeGenericModal();
            };

            addNewContainer.querySelector( '[data-id="btnCancel"]' ).addEventListener( 'click', onCloseAddNewContainer );
            addNewContainer.querySelectorAll( '[data-type="btnAdd"]' ).forEach( ( btn ) =>
            {
                btn.addEventListener( 'click', () => {
                    const addEvent = new CustomEvent(
                        "add",
                        {
                            detail : {
                                id : btn.getAttribute( 'data-routine-id' ),
                                goal : btn.getAttribute( 'data-goal' ),
                                categoryId : btn.getAttribute( 'data-category-id' ),
                                name : btn.getAttribute( 'data-name' ).replace( '__WT__', btn.getAttribute( 'data-weekly-frequence' ) ),
                                icon : btn.getAttribute( 'data-icon' ),
                                weeklyFrequence : btn.getAttribute( 'data-weekly-frequence' )
                            }
                        }
                    );
                    this.onUpdateRoutinePlanRequest( addEvent );
                    onCloseAddNewContainer();
                } );
            });
            addNewContainer.querySelectorAll( '[ data-type="weekly-frequence-selector"]' ).forEach( ( select ) =>
            {
                select.addEventListener( 'change', ( changeEvent ) =>
                {
                    addNewContainer.querySelector( '[data-type="btnAdd"][data-routine-id="' + changeEvent.target.getAttribute( 'data-routine-id' ) + '"]' ).setAttribute( 'data-weekly-frequence', changeEvent.target.value );
                    changeEvent.target.blur();
                });
            });

            addNewContainer.querySelector( '[data-id="btnSelectIndividualIcon"]' ).addEventListener( 'click', () =>
            {
                const iconSelectContainer = this.app.gui.getIndividualItemModalContainer();
                const onItemSelect = function( src = null )
                {
                    if ( src )
                    {
                        addNewContainer.querySelector( '[data-id="btnSelectIndividualIcon"]' ).setAttribute(
                            'data-icon-src',
                            src
                        );
                        addNewContainer.querySelector( '[data-id="btnSelectIndividualIcon"] > img' ).setAttribute(
                            'src',
                            '/assets/icons/routines/' + src
                        );
                    }
                    document.querySelector( '[data-id="static-backdrop"]' ).style.zIndex = 'auto';
                    iconSelectContainer.classList.remove( 'menu-active' );
                    iconSelectContainer.querySelectorAll( '[data-type="individualItem"]' ).forEach( btn => btn.removeEventListeners( 'click' ) );
                    iconSelectContainer.querySelector( '[data-id="btnCloseIconSelection"]' ).removeEventListeners( 'click' );
                };

                document.querySelector( '[data-id="static-backdrop"]' ).style.zIndex = 52;
                iconSelectContainer.classList.add( 'menu-active' );
                iconSelectContainer.querySelectorAll( '[data-type="individualItem"]' ).forEach( btn =>
                {
                    btn.addEventListener( 'click', ( clickEvent ) =>
                    {
                        onItemSelect( clickEvent.currentTarget.getAttribute( 'data-item-src' ) );
                    });
                });
                iconSelectContainer.querySelector( '[data-id="btnCloseIconSelection"]' ).addEventListener( 'click', () =>
                {
                    onItemSelect( null );
                });
            });

            addNewContainer.querySelector( '[data-id="addIndividualRoutineCategoryId"]' ).addEventListener( 'change', ( selectEvent) =>
            {
                const frequenceSelector = addNewContainer.querySelector( '[data-id="addIndividualRoutineWeeklyFrequence"]' );
                if ( 'weekly-goal' === selectEvent.currentTarget.value )
                {
                    frequenceSelector.removeAttribute( 'disabled' );
                }
                else
                {
                    frequenceSelector.value = '7';
                    frequenceSelector.setAttribute( 'disabled', 'disabled' );
                }
            });

            addNewContainer.querySelector( '[data-id="btnAddIndividual"]' ).addEventListener( 'click', () =>
            {
                const form = addNewContainer.querySelector( '[data-id="addIndividualRoutineForm"]' );
                form.classList.add( 'was-validated' );
                if ( true === form.checkValidity() )
                {
                    form.classList.remove( 'was-validated' );
                    const formValues = IF.Helper.serializeForm( form );
                    const addEvent = new CustomEvent(
                        "add",
                        {
                            detail : {
                                id : "0",
                                goal : formValues.addIndividualRoutineCategoryId === 'weekly-goal' ? 'weekly' : 'daily',
                                categoryId : formValues.addIndividualRoutineCategoryId,
                                name : formValues.addIndividualRoutineCategoryId === 'weekly-goal' ? `${formValues.addIndividualRoutineWeeklyFrequence} mal ${IF.Helper.trim( formValues.addIndividualRoutineName )}`: IF.Helper.trim( formValues.addIndividualRoutineName ),
                                icon : addNewContainer.querySelector( '[data-id="btnSelectIndividualIcon"]' ).getAttribute( 'data-icon-src' ),
                                weeklyFrequence : formValues.addIndividualRoutineCategoryId === 'weekly-goal' ?  formValues.addIndividualRoutineWeeklyFrequence : 7
                            }
                        }
                    );
                    this.onUpdateRoutinePlanRequest( addEvent );
                    onCloseAddNewContainer();
                }
            });
        });
    }

    async loadPageContent( newRoutinePlan = null )
    {
        this.routinePlan = null;

        this.app.container.querySelectorAll( 'routine-selection-edit' ).forEach( ( elem ) =>
        {
            elem.removeEventListeners( 'updateRoutinePlanRequest' );
        });

        this.app.container.querySelector( '[data-id="routineSettingsListContainer"]' ).innerHTML = '---';

        if ( null === newRoutinePlan )
        {
            const resp = await this.app.api.get(  '/routine/draft' );
            if ( 200 === resp.status )
            {
                const nextRoutineData = await resp.json();
                this.routinePlan = new RoutinePlan( nextRoutineData );
            }
        }
        else
        {
            this.routinePlan = newRoutinePlan;
        }

        this.app.container.querySelector( '[data-id="routineSettingsListContainer"]' ).innerHTML = this.app.view.getHtml(
            listTemplate,
            {
                routinePlan: this.routinePlan
            }
        );

        this.app.container.querySelectorAll( 'routine-selection-edit' ).forEach( ( elem ) =>
        {
            elem.addEventListener( 'updateRoutinePlanRequest', this.onUpdateRoutinePlanRequest.bind( this ) );
        });
    }

    async onUpdateRoutinePlanRequest( event )
    {
        this.app.gui.showPageLoader( 'Routinen werden aktualisiert...' );
        const routinePatch = [];
        this.app.container.querySelectorAll( 'routine-selection-edit' ).forEach( ( elem ) =>
        {
            if ( false === elem.hasAttribute( 'to-delete' ) )
            {
                routinePatch.push( elem.getValues() );
            }
        });

        if ( event && "add" === event.type )
        {
            routinePatch.push( event.detail );
        }

        const patchResponse = await this.app.api.patch(
            '/routine/' + this.routinePlan.id,
            {
                routines : routinePatch
            }
        );
        if ( 200 === patchResponse.status )
        {
            const newRoutinePlanData = await patchResponse.json();
            this.loadPageContent( new RoutinePlan( newRoutinePlanData ) );
            this.app.gui.showSnackbarConfirmed( 'Routine angepasst.' );
        }
        else
        {
            this.app.gui.showSnackbarError( 'Routineanpassungen konnten nicht gespeichert werden.' );
        }

        this.app.gui.hidePageLoader();
    }

    async exit()
    {
        this.app.container.querySelector( '[data-id="btnAction"]' ).removeEventListeners( 'click' );
        this.app.container.querySelectorAll( 'routine-selection-edit' ).forEach( ( elem ) =>
        {
            elem.removeEventListeners( 'updateRoutinePlanRequest' );
        });
    }
};
